import PropTypes from "prop-types";
import React from "react";

import { defaultFilterCall } from '../../store/actions'
import { useDispatch, connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { CardTitle } from "reactstrap";

const ContentHeader = props => {
    const url = window.location.pathname
    const dispatch = useDispatch();
    const { defaultFilter } = props.layout;
    const handleFilter = (filterValue) => {
        const pickup = defaultFilterCall(filterValue);
        dispatch(pickup)
    }

    if (url !== '/dashboard') {
        return false;
    }

    return (
        <div className="w-full">
            {/* <div className='row m-0 card'>
                <div className='col-12' style={{
                    display: 'flex',
                    padding: '14px',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <CardTitle className="m-0">Dashboard</CardTitle>
                    <div className='gap-1 d-flex'>
                        <button className={`btn btn-outline-dark p-1 ${defaultFilter == 'today' ? 'active' : ''}`} onClick={() => handleFilter('today')}>Today</button>
                        <button className={`btn btn-outline-dark p-1 ${defaultFilter == '7-days' ? 'active' : ''}`} onClick={() => handleFilter('7-days')}>7 Days</button>
                        <button className={`btn btn-outline-dark p-1 ${defaultFilter == '30-days' ? 'active' : ''}`} onClick={() => handleFilter('30-days')}>30 Days</button>
                        <button className={`btn btn-outline-dark p-1 ${defaultFilter == '90-days' ? 'active' : ''}`} onClick={() => handleFilter('90-days')}>Last 90 Days</button>
                        <button className={`btn btn-outline-dark p-1 ${defaultFilter == '180-days' ? 'active' : ''}`} onClick={() => handleFilter('180-days')}>Last 180 Days</button>
                        <button className={`btn btn-outline-dark p-1 ${defaultFilter == 'yearly' ? 'active' : ''}`} onClick={() => handleFilter('yearly')}>Yearly</button>
                    </div>
                </div>
            </div> */}
        </div>
    )
}

ContentHeader.propTypes = {
    layout: PropTypes.any
}

const mapStatetoProps = state => {
    return {
        layout: state.Layout,
    };
};

export default connect(
    mapStatetoProps,
    {}
)(withRouter(withTranslation()(ContentHeader)));
